import type { CanvassHouse } from "@/canvasses/types";
import { computed, toValue, type MaybeRefOrGetter } from "vue";

type CanvassHouseStatus = "completed" | "wip" | "pending";

export function canvassHouseStatusToColor(status: CanvassHouseStatus) {
  switch (status) {
    case "completed":
      return "var(--fill-color-green)";
    case "wip":
      return "var(--fill-color-yellow)";
    case "pending":
      return "var(--fill-color-grey)";
  }
}

export function useCanvassHouseColor(
  canvassHouseRef: MaybeRefOrGetter<CanvassHouse>,
) {
  const status = computed((): CanvassHouseStatus => {
    const canvassHouse = toValue(canvassHouseRef);

    if (canvassHouse.completed) return "completed";
    if (canvassHouse.doorsKnocked > 0) return "wip";
    return "pending";
  });

  return computed(() => canvassHouseStatusToColor(status.value));
}
